import React, { Component } from 'react';

import './css/OpenQuestion.css';
import StringUtils from "../../utils/StringUtils";

class OpenQuestion extends Component {
    state = {
        answer: ''
    }

    componentDidMount() {
        this.props.saveAnswer(this.props.id, '');
    }

    handleChange = (event) => {
        this.setState({ answer: event.target.value });
        this.props.saveAnswer(this.props.id, event.target.value);
    }


    render() {
        const inputBox = this.props.multiline ? (<textarea onInput={this.handleChange} onChange={this.handleChange} className="answer" value={this.state.answer} />) : (<input onInput={this.handleChange} onChange={this.handleChange} type="text" className="answer" value={this.state.answer} />)

        return (
            <div className="task-block open-question">
                <div className="question-number">Pytanie {this.props.questionNumber}</div>
                <div className="question">{StringUtils.parse(this.props.question)}</div>
                {inputBox}
            </div>
        );
    }
}

export default OpenQuestion;